var $ = require('jquery');
var auth = require('../auth');
var style = $('<style>' + require('../assets/style.css').toString() + '</style>');
require('./tmpl-renderer');

var VALID_SUCCESS = 'success.valid', VALID_ERROR = 'error.valid', REG_MOBILE = /^1\d{10}$/;

function appendStyle() {
    $('head').append(style);
}

$.fn.ycgameRegisterForm = function (globalOptions) {
    appendStyle();

    this.each(function () {
        var $form = $(this);
        // var $normalElements = $form.find('[role=ycgame-register-normal-inputs]');
        var $mobileElements = $form.find('[role=ycgame-register-mobile-inputs]');
        var $sendSmsCaptcha = $form.find('[role="ycgame-register-send-sms"]');
        var $imgCaptcha = $form.find('img[role="ycgame-register-captcha-img"]');
        var $rowCaptcha = $imgCaptcha.parent().hide();
        var $username = $form.find('[name=username]').size() ? $form.find('[name=username]') : $form.find('[name=mobile]');
        var imgCaptchaRow = {
            enable: function (focus) {
                if ($rowCaptcha.is(':hidden')) {
                    $rowCaptcha.show();
                    $imgCaptcha.click();
                    var $input = $rowCaptcha.find('input').prop('disabled', false);
                }

                focus && $input.focus();
            },
            disable: function () {
                $rowCaptcha.hide();
                $rowCaptcha.find('input').prop('disabled', true);
            }
        };
        var smsCaptchaRow = {
            enable: function () {
                $mobileElements.show().find('input').prop('disabled', false);
            },
            disable: function () {
                $mobileElements.hide().find('input').prop('disabled', true);
            }
        };

        imgCaptchaRow.disable();
        smsCaptchaRow.disable();

        var options = $.extend({
            waitingText: $sendSmsCaptcha.data('waiting-text') || '等待{sec}秒后再试',
            successTmpl: $form.next('script[type="text/x-template"]'),
            // successHiddenElement: $form,
            defaultInputEvents: true
        }, globalOptions);

        if (options.defaultInputEvents) {
            $form.on(VALID_SUCCESS + ' ' + VALID_ERROR, 'input:text,input:password', function (e) {
                var $tip = $(this).data('tip');
                if (!$tip) {
                    $tip = $('<span class="yc-icon"></span>');
                    $(this).data('tip', $tip);
                }
                $(this).after($tip);
                if (e.type == 'success') {
                    $tip.addClass('yc-icon-success').removeClass('yc-icon-wrong');
                } else {
                    $tip.removeClass('yc-icon-success').addClass('yc-icon-wrong');
                }
            });
        }
        if (options.successTmpl) {
            $form.on('success.submit', function () {
                $form.ycgameTmplRender({template: options.successTmpl});
            });
        }

        $form.on('keyup change blur focus', '[name=username]', function (e) {
            if ($.trim(this.value) != this.value) { //为不影响用户输入光标
                this.value = $.trim(this.value);
            }
        })
            .on('blur', '[name=mobile]', function (e) {
                var self = $(this);
                var val = self.val();
                if (!val) {
                    self.trigger(VALID_ERROR, ['请输入手机号']);
                    return false;
                }

                if (!REG_MOBILE.test(val)) {
                    self.trigger(VALID_ERROR, ['手机号格式错误，请输入手机号']);
                    return false;
                }

                auth.exists(val).done(function () {
                    self.trigger(VALID_SUCCESS);
                }).fail(function (rs, msg) {
                    self.trigger(VALID_ERROR, [msg]);
                });
            })
            .on('blur', '[name=username]', function (e) {
                var self = $(this);
                var val = self.val();
                if (!val) {
                    self.trigger(VALID_ERROR, ['请输入手机号或个性账号(6~16位的字母或数字，以字母开头)']);
                    return false;
                }

                if (/^1\d{5,}$/.test(val)) {
                    if (!REG_MOBILE.test(val)) {
                        self.trigger(VALID_ERROR, ['手机号格式错误，请输入手机号或个性账号']);
                        return false;
                    }
                } else {
                    if (!/^[a-zA-Z][a-zA-Z0-9]{5,15}$/.test(val)) {
                        self.trigger(VALID_ERROR, ['个性账号格式错误，请输入6~16位的字母或数字，以字母开头']);
                        return false;
                    }
                }

                auth.exists(val).done(function () {
                    self.trigger(VALID_SUCCESS);
                }).fail(function (rs, msg) {
                    self.trigger(VALID_ERROR, [msg]);
                });
            })
            .on('blur', '[name=password]', function () {
                var self = $(this);
                var val = this.value;
                var regP = /^[ -~]{8,18}$/;
                var regP2 = /^([ -~])\1{7,}$/;
                var regP3 = /^.{8,18}$/;
                if (!val) {
                    self.trigger(VALID_ERROR, ['密码不能为空']);
                    return;
                }
                if (!regP3.test(val)) {
                    self.trigger(VALID_ERROR, ['密码长度为8-18位']);
                    return;
                }
                if (!regP.test(val)) {
                    self.trigger(VALID_ERROR, ['密码字符有误']);
                    return;
                }
                //同一字符密码返回true
                if (regP2.test(val)) {
                    self.trigger(VALID_ERROR, ['密码不允许为同一字符']);
                    return;
                }

                self.trigger(VALID_SUCCESS);
            })
            .on('blur', '[name=sms_captcha]', function () {
                var self = $(this);
                if (!this.value) {
                    self.trigger(VALID_ERROR, ['请输入短信验证码']);
                    return;
                }

                self.trigger(VALID_SUCCESS);
            })
            .on('click', '[role="ycgame-register-send-sms"]', function () {
                var self = $(this);
                var waitingText = options.waitingText;
                var defaultText = self.html();
                var username = $username.val();
                var $imgCaptchaInput = $form.find('[name=captcha]');

                if (!$username.data('valid')) {
                    $username.trigger('blur');
                    $username.focus();
                    return false;
                }
                if (!$imgCaptchaInput.data('valid')) {
                    $imgCaptchaInput.trigger('blur');
                    $imgCaptchaInput.focus();
                    return false;
                }

                self.prop('disabled', true);
                self.text('发送中…');
                var defer = auth.getVerifyCode(username, $imgCaptchaInput.val());
                defer.done(function () {
                    self.trigger('send.success');
                }).fail(function (rs, msg) {
                    self.prop('disabled', false);
                    self.trigger('send.error', [msg || '服务器繁忙，请稍后再试']);
                });
                if (waitingText) {
                    defer.done(function () {
                        var countdown = 60;

                        function sendBtnCountdown() {
                            if (countdown <= 0) {
                                self.html(defaultText);
                                self.prop('disabled', false);
                            } else {
                                self.text(waitingText.replace('{sec}', countdown));
                                countdown--;
                                setTimeout(sendBtnCountdown, 1000);
                            }
                        }

                        sendBtnCountdown();
                    });
                }
            })
            .on('blur', '[name=confirm_password]', function () {
                var self = $(this);
                if (!this.value) {
                    self.trigger(VALID_ERROR, ['请再次输入确认密码']);
                    return false;
                }

                if (this.value !== $form.find('[name=password]').val()) {
                    self.trigger(VALID_ERROR, ['两次输入的密码不一致']);
                    return false;
                }

                self.trigger(VALID_SUCCESS);
            })
            .on('blur', '[name=idcard]', function () {
                var self = $(this);
                if (!idcardValidator(this.value)) {
                    self.trigger(VALID_ERROR, ['身份证格式错误']);
                    return;
                }
                self.trigger(VALID_SUCCESS);
            })
            .on('blur', '[name=captcha]', function (e) {
                var self = $(this), val = this.value;
                // console.log(self.selector, e.type);
                if (!val) {
                    self.trigger(VALID_ERROR, ['请输入图形验证码']);
                } else if (val.length !== 5) {
                    self.trigger(VALID_ERROR, ['请输入5位长度的图形验证码']);
                }
            })
            .on('keyup change blur', '[name=captcha]', function (e) {
                var self = $(this), val = this.value;
                // console.log('captcha', e.type, val);
                if (val.length === 5) {
                    self.trigger(VALID_SUCCESS);
                } else if (self.data('valid')) {
                    self.trigger(VALID_ERROR, ['请输入5位长度的图形验证码']);
                }
            })
            .on('click blur', 'input[name=agree]', function () {
                var self = $(this);
                if (!this.checked) {
                    var msg = '请确认已查看并同意《服务协议与隐私声明》';
                    self.trigger(VALID_ERROR, [msg]);
                } else {
                    self.trigger(VALID_SUCCESS);
                }
            })
            .on('click', 'img[role="ycgame-register-captcha-img"]', function (e) {
                e.preventDefault();
                this.src = auth.getImgCodeSrc();
            })
            .on(VALID_ERROR + ' ' + VALID_SUCCESS, 'input', function (e) {
                $(this).data('valid', e.type === 'success');
            })
            .on(VALID_SUCCESS, $username.selector, function (e) {
                if (REG_MOBILE.test($username.val())) {
                    imgCaptchaRow.enable();
                }
            })
            .on(VALID_SUCCESS, '[name=captcha]', function (e) {
                var val = $username.val();

                if (REG_MOBILE.test(val)) {
                    smsCaptchaRow.enable();
                } else {
                    smsCaptchaRow.disable();
                }
            })
            .on('submit', function (e) {
                e.preventDefault();
                var $self = $(this), canSubmit = true, self = this;
                $self.find('input:enabled').each(function () {
                    var $input = $(this);
                    if ($input.data('valid') === false) {
                        canSubmit = false;
                        this.focus();
                        return false;
                    } else if (!$input.data('valid')) {
                        $input.trigger('blur');
                        canSubmit = $input.data('valid');
                        if (!canSubmit) {
                            this.focus();
                            return false;
                        }
                    }
                });
                var agreed = $self.find('input[name=agree]').prop('checked');
                if (!agreed) {
                    $self.trigger('error.submit', ['请确认已查看并同意《服务协议与隐私声明》']);
                    return;
                }

                var username = self.username || self.mobile;

                if (canSubmit) {
                    var defer;
                    if (REG_MOBILE.test(username.value)) {
                        defer = auth.regMobile(
                            username.value,
                            self.password.value,
                            self.idcard.value,
                            self.captcha.value,
                            self['sms_captcha'].value
                        );
                    } else {
                        defer = auth.regUsername(//username, password, realname, idcard, imgCapthca, type, g)
                            username.value,
                            self.password.value,
                            '',
                            self.idcard.value,
                            self.captcha.value
                        );
                    }
                    defer.always(function (rs, msg) {
                        if (rs && rs.ok == 17) {
                            imgCaptchaRow.enable();
                        }
                    });
                    defer.done(function (rs) {
                        $self.trigger('success.submit', rs);
                    }).fail(function (rs, msg) {
                        $self.trigger('error.submit', [msg]);
                    });
                }
            });
    });
};

function idcardValidator(value) {
    var y, l, reg;
    var areas = [11, 12, 13, 14, 15, 21, 22, 23, 31, 32, 33, 34, 35, 36, 37, 41,
        42, 43, 44, 45, 46, 50, 51, 52, 53, 54, 61, 62, 63, 64, 65, 71,
        81, 82, 91];

    if ($.inArray(parseInt(value.substr(0, 2), 10), areas) === -1) {
        return false;
    }

    switch (value.length) {
        case 15:
            y = parseInt(value.substr(6, 2), 10) + 1900;
            l = (y % 4 === 0 || y % 400 === 0) ? 9 : 8;
            reg = '^[1-9][0-9]{5}[0-9]{2}((01|03|05|07|08|10|12)(0[1-' +
                '9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-' +
                '9]|30)|02(0[1-9]|1[0-9]|2[0-' + l + ']))[0-9]{3}$';
            break;
        case 18:
            y = parseInt(value.substr(6, 4), 10);
            l = (y % 4 === 0 || y % 400 === 0) ? 9 : 8;
            reg = '^[1-9][0-9]{5}(18|19|20)[0-9]{2}((01|03|05|07|08|10|' +
                '12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1' +
                '-2][0-9]|30)|02(0[1-9]|1[0-9]|2[0-' + l + ']))[0-9]{3}[0-9Xx' +
                ']$';
            break;
        default:
            return false;
    }
    return (new RegExp(reg)).test(value);
}



//////////////////
// WEBPACK FOOTER
// ./components/register-form.js
// module id = 4
// module chunks = 0